module.exports = __webpack_public_path__ + "img/online.79e80d4f.svg";